// extracted by mini-css-extract-plugin
export default {"card":"Card_card__UvSb3","imageContainer":"Card_imageContainer__hB-Ru","image":"Card_image__4r0I+","seeMore":"Card_seeMore__cpGfM","heart":"Card_heart__FjfpH"};